import React from 'react';
import { AccessibilityContext } from '@/contexts/accessibility';

export const useAccessibility = () => React.useContext(AccessibilityContext);
